import styled, { css } from 'styled-components';
import { getMediaQuery } from '@carvana/showroom-theme';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';

export const HeroLoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  color: ${(props) => props.theme.color.neutral.v000};
  padding: 4rem 1rem 1rem;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    color: ${(props) => props.theme.color.neutral.v100};
    padding: 2rem 1rem 0;
  }
`;

export const HeroLoginText = styled.div`
  font-size: 0.9rem;
  padding-bottom: 1rem;
`;

export const ButtonSize = css`
  padding: 0 10px;

  ${(props) => getMediaQuery(props.theme.breakpoint.sm)} {
    padding: unset;
  }

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    padding: 0 20px;
    width: 13rem;
  }
`;

export const SignInButton = styled(PrimaryButton)`
  ${ButtonSize}
`;

export const CreateAccountButton = styled(SecondaryButton)`
  ${ButtonSize}

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    background: ${(props) => props.theme.color.neutral.v100} !important;
    color: ${(props) => props.theme.color.primary.v200};

    &:hover {
      background: ${(props) => props.theme.color.primary.v200} !important;
    }
  }
`;

export const Paragraph = styled.span`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  color: ${(props) => props.theme.color.primary.v600};

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    color: ${(props) => props.theme.color.neutral.v100};
  }
`;
